import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const RankBtn = styled(Button)({
  height: "40px",
  lineHeight: "40px",
  maxHeight: "40px",
  width: "auto",
  padding: "0 12px",
  color: "#22D758",
  fontSize: 14,
  fontFamily: "Gill Sans",
  textTransform: "initial",
  background: "rgba(149, 0, 255, 0.05)",
  border: "1px solid",
  borderColor: "#22D758",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid",
    borderColor: "#22D758",
    color: "#FFFFFF",
    background: "#22D758",
  },
});
